import { useQuery } from '@tcs/common/hooks/useQuery';
import { useState, useEffect } from 'react';

const useDataAsOfDate = () => {
  const {
    data,
    isLoading: loading,
    isError,
  } = useQuery<string, Error>(`/dataAsOf`, {
    refetchOnMount: false,
  });

  const [currentAsOfDate, setCurrentAsOfDate] = useState<Date | null>(null);

  useEffect(() => {
    // Return null if loading, error, or data is missing
    if (loading || isError || !data) {
      return;
    }

    // Validate that data can be converted to a valid date
    const reportedAsOfDate = new Date(data);
    if (isNaN(reportedAsOfDate.getTime())) {
      // Invalid date, don't update
      return;
    }

    // compare by millisecond number, not Date object reference
    // you could also do this by comparing the string resulting from the query rather than converting it to a date
    const reportedDateString = reportedAsOfDate.toISOString().split('T')[0];

    setCurrentAsOfDate((prevDate) => {
      if (prevDate === null) {
        return new Date(reportedAsOfDate);
      }
      const currentDateString = prevDate.toISOString().split('T')[0];
      if (reportedDateString !== currentDateString) {
        return new Date(reportedAsOfDate);
      }
      return prevDate;
    });
  }, [data, loading, isError]);

  if (loading) {
    return null;
  }

  return currentAsOfDate;
};

export default useDataAsOfDate;
